import { FC } from 'react';
import ReadonlyView from '@/components/form/readonly-view';
import { ReadonlyField } from '@/components/form/readonly-view/helpers';
import ExternalLink from '@/components/external-link';
import { getHostname } from '@/lib/url-helpers';
import { PublicServiceModel } from '@/lib/models/public-service/public-service.model';
import NoneChip from '@/components/chip/none-chip';
import Text from '@/components/text';

interface Props {
  publicService: PublicServiceModel;
}

const readOnlyFields: ReadonlyField[] = [
  { label: 'Company', prop: 'company', rowGroup: 'company' },
  { label: 'Country', prop: 'country', rowGroup: 'company' },
  { label: 'Website', prop: 'website', rowGroup: 'company' },
  { label: 'Description', prop: 'description' },
];

const getReadonlyData = (data: PublicServiceModel | null) => {
  if (!data) {
    return {};
  }

  const { name, description, website, signals, companyName } = data;
  const countryName = signals?.companyCountry?.value;
  const NaChipEl = <NoneChip notAvailable />;

  return {
    name,
    company: <Text>{companyName.value}</Text>,
    description,
    country: countryName || NaChipEl,

    website: <ExternalLink href={website} label={getHostname(website)} withIcon />,
  };
};

export const CompanyProfile: FC<Props> = ({ publicService }) => {
  return <ReadonlyView fields={readOnlyFields} data={getReadonlyData(publicService)} />;
};

export default CompanyProfile;
